export default __webpack_public_path__ + "static/mermaid-d8dde2e3cffde239d35fdd08ae652713.svg";